module.exports = __webpack_public_path__ + "img/imagenUnoInformática.4b916d25.jpg";